module.exports = __webpack_public_path__ + "img/340.9c025592.jpg";